import React from 'react'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import WaveLoading from 'components/share/WaveLoading'

const PreWorkWidgetLoadingGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)

  if (!widgetData || widgetData.preWorkStatus === 'loading') return <WaveLoading />

  return children
}

export default PreWorkWidgetLoadingGuard
